export function empty (validate) {

  return (
    (
      typeof validate === 'undefined' ||
      validate === null
    ) ||
    (
      typeof validate === 'string' &&
      (
        validate.trim().length === 0 ||
         validate.trim().toString() === '0'
      )
    )
  ) ||
  false
}